// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: Teams meeting links: which ones Konvo can join itself, and how the ACS SDK should find them.

/** Whether a link is a Teams meeting link the SDK can join. */
export function isTeamsMeetingLink(url: string): boolean {
	try {
		const parsed = new URL(url);
		return (
			parsed.protocol === 'https:' &&
			/(^|\.)teams\.(microsoft|live)\.com$/.test(parsed.hostname) &&
			/^\/(l\/meetup-join|meet)\//.test(parsed.pathname)
		);
	} catch {
		return false;
	}
}

/**
 * How the SDK should find the meeting: the newer short links (teams.microsoft.com/meet/<id>?p=<code>)
 * join by meeting id and passcode, the classic meetup-join links by the link itself.
 */
export function teamsMeetingLocator(url: string): {meetingId: string; passcode?: string} | {meetingLink: string} {
	try {
		const parsed = new URL(url);
		const short = /^\/meet\/(\d{6,})\/?$/.exec(parsed.pathname);
		if (short) {
			const passcode = parsed.searchParams.get('p') ?? undefined;
			return passcode ? {meetingId: short[1], passcode} : {meetingId: short[1]};
		}
	} catch {
		// fall through: let the SDK judge the link
	}
	return {meetingLink: url};
}
